/* tslint:disable */
/* eslint-disable */
/**
 * HR Recruiter API — Companies
 * OpenAPI спецификация для управления компаниями в SaaS-архитектуре. Самодостаточный файл для генерации и документации. 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@hr-recruiter.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * Запрос на назначение владельца компании
 * @export
 * @interface AssignOwnerRequest
 */
export interface AssignOwnerRequest {
    /**
     * ID пользователя, который будет назначен владельцем
     * @type {number}
     * @memberof AssignOwnerRequest
     */
    'ownerId': number;
}
/**
 * 
 * @export
 * @interface CompaniesPaginatedResponse
 */
export interface CompaniesPaginatedResponse {
    /**
     * Список компаний на текущей странице
     * @type {Array<Company>}
     * @memberof CompaniesPaginatedResponse
     */
    'content': Array<Company>;
    /**
     * Общее количество элементов
     * @type {number}
     * @memberof CompaniesPaginatedResponse
     */
    'totalElements': number;
    /**
     * Общее количество страниц
     * @type {number}
     * @memberof CompaniesPaginatedResponse
     */
    'totalPages': number;
    /**
     * Номер текущей страницы (начиная с 0)
     * @type {number}
     * @memberof CompaniesPaginatedResponse
     */
    'number': number;
    /**
     * Размер страницы
     * @type {number}
     * @memberof CompaniesPaginatedResponse
     */
    'size': number;
}
/**
 * Полная информация о компании
 * @export
 * @interface Company
 */
export interface Company {
    /**
     * Уникальный идентификатор компании
     * @type {number}
     * @memberof Company
     */
    'id': number;
    /**
     * Название компании
     * @type {string}
     * @memberof Company
     */
    'name': string;
    /**
     * Описание компании
     * @type {string}
     * @memberof Company
     */
    'description'?: string | null;
    /**
     * Статус компании: ACTIVE=Активная, PILOT=Пилотная, SUSPENDED=На паузе, INACTIVE=Заблокирована
     * @type {string}
     * @memberof Company
     */
    'status': CompanyStatus;
    /**
     * ID владельца компании
     * @type {number}
     * @memberof Company
     */
    'ownerId'?: number | null;
    /**
     * ФИО владельца компании
     * @type {string}
     * @memberof Company
     */
    'ownerName'?: string | null;
    /**
     * Email владельца компании (логин)
     * @type {string}
     * @memberof Company
     */
    'ownerEmail'?: string | null;
    /**
     * URL логотипа компании
     * @type {string}
     * @memberof Company
     */
    'logoUrl'?: string | null;
    /**
     * Текущий рублёвый баланс компании в копейках
     * @type {number}
     * @memberof Company
     */
    'balanceKopecks': number;
    /**
     * Дата начала пилотного периода
     * @type {string}
     * @memberof Company
     */
    'pilotStartDate'?: string | null;
    /**
     * Дата начала активной подписки
     * @type {string}
     * @memberof Company
     */
    'subscriptionStartDate'?: string | null;
    /**
     * Максимальное количество аккаунтов (мест) в компании
     * @type {number}
     * @memberof Company
     */
    'maxAccounts'?: number | null;
    /**
     * Текущее количество аккаунтов в компании
     * @type {number}
     * @memberof Company
     */
    'accountsCount'?: number;
    /**
     * 
     * @type {CompanyStats}
     * @memberof Company
     */
    'stats'?: CompanyStats;
    /**
     * Дата и время создания компании
     * @type {string}
     * @memberof Company
     */
    'createdAt': string;
    /**
     * Дата и время последнего обновления компании
     * @type {string}
     * @memberof Company
     */
    'updatedAt': string;
    /**
     * Разрешено ли использование eStaff для компании
     * @type {boolean}
     * @memberof Company
     */
    'estaffEnabled'?: boolean;
}

export const CompanyStatus = {
    ACTIVE: 'ACTIVE',
    PILOT: 'PILOT',
    SUSPENDED: 'SUSPENDED',
    INACTIVE: 'INACTIVE'
} as const;

export type CompanyStatus = typeof CompanyStatus[keyof typeof CompanyStatus];

/**
 * Статистика баланса компании с прогнозом дней
 * @export
 * @interface CompanyBalanceStats
 */
export interface CompanyBalanceStats {
    /**
     * Текущий баланс в копейках
     * @type {number}
     * @memberof CompanyBalanceStats
     */
    'balanceKopecks'?: number;
    /**
     * Изменение баланса за период (Σ пополнений − Σ списаний нетто SPEND−REFUND). Положительное — прирост, отрицательное — убыль. Используется колонкой «Баланс».
     * @type {number}
     * @memberof CompanyBalanceStats
     */
    'balanceDeltaKopecks'?: number;
    /**
     * Прогноз дней до исчерпания баланса (null если нет данных)
     * @type {number}
     * @memberof CompanyBalanceStats
     */
    'prognosisDays'?: number | null;
    /**
     * Текст прогноза (~22 дн. лимита / 90+ дней лимита / Услуги отключены)
     * @type {string}
     * @memberof CompanyBalanceStats
     */
    'prognosisText'?: string | null;
    /**
     * true если баланс <= 0
     * @type {boolean}
     * @memberof CompanyBalanceStats
     */
    'servicesDisabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CompanyBalanceStats
     */
    'searchKopecks'?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyBalanceStats
     */
    'searchUnits'?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyBalanceStats
     */
    'dialogKopecks'?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyBalanceStats
     */
    'dialogUnits'?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyBalanceStats
     */
    'interviewKopecks'?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyBalanceStats
     */
    'interviewUnits'?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyBalanceStats
     */
    'totalSpentKopecks'?: number;
}
/**
 * Запрос на создание компании
 * @export
 * @interface CompanyCreateRequest
 */
export interface CompanyCreateRequest {
    /**
     * Название компании
     * @type {string}
     * @memberof CompanyCreateRequest
     */
    'name': string;
    /**
     * Email владельца (логин для входа)
     * @type {string}
     * @memberof CompanyCreateRequest
     */
    'ownerEmail': string;
    /**
     * Описание деятельности компании
     * @type {string}
     * @memberof CompanyCreateRequest
     */
    'description'?: string | null;
    /**
     * Начальный баланс компании в копейках
     * @type {number}
     * @memberof CompanyCreateRequest
     */
    'initialBalanceKopecks'?: number;
    /**
     * Максимальное количество мест (аккаунтов)
     * @type {number}
     * @memberof CompanyCreateRequest
     */
    'maxAccounts'?: number;
    /**
     * Дата начала подписки
     * @type {string}
     * @memberof CompanyCreateRequest
     */
    'subscriptionStartDate'?: string | null;
    /**
     * Дата начала пилота
     * @type {string}
     * @memberof CompanyCreateRequest
     */
    'pilotStartDate'?: string | null;
    /**
     * Цена скоринга резюме за единицу в копейках
     * @type {number}
     * @memberof CompanyCreateRequest
     */
    'searchCreditsPriceKopecks'?: number;
    /**
     * Цена диалога с ИИ за единицу в копейках
     * @type {number}
     * @memberof CompanyCreateRequest
     */
    'dialogCreditsPriceKopecks'?: number;
    /**
     * Цена ИИ-скрининга за единицу в копейках
     * @type {number}
     * @memberof CompanyCreateRequest
     */
    'interviewCreditsPriceKopecks'?: number;
    /**
     * Разрешено ли использование eStaff
     * @type {boolean}
     * @memberof CompanyCreateRequest
     */
    'estaffEnabled'?: boolean;
}
/**
 * Аналитика по ИИ-модулям компании за период с финансовой эффективностью. Маржа/прибыль считаются на фронте из копеек.
 * @export
 * @interface CompanyModuleAnalytics
 */
export interface CompanyModuleAnalytics {
    /**
     * 
     * @type {number}
     * @memberof CompanyModuleAnalytics
     */
    'companyId': number;
    /**
     * 
     * @type {string}
     * @memberof CompanyModuleAnalytics
     */
    'companyName': string;
    /**
     * 
     * @type {string}
     * @memberof CompanyModuleAnalytics
     */
    'companyDescription'?: string | null;
    /**
     * Текущие средства компании в копейках
     * @type {number}
     * @memberof CompanyModuleAnalytics
     */
    'balanceKopecks': number;
    /**
     * 
     * @type {string}
     * @memberof CompanyModuleAnalytics
     */
    'dateFrom'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyModuleAnalytics
     */
    'dateTo'?: string | null;
    /**
     * 
     * @type {Array<CompanyModuleAnalyticsItem>}
     * @memberof CompanyModuleAnalytics
     */
    'modules': Array<CompanyModuleAnalyticsItem>;
    /**
     * Итого выручено за период в копейках
     * @type {number}
     * @memberof CompanyModuleAnalytics
     */
    'revenueKopecks': number;
    /**
     * Итого себестоимость за период в копейках
     * @type {number}
     * @memberof CompanyModuleAnalytics
     */
    'costKopecks': number;
    /**
     * Прибыль = выручка - себестоимость в копейках
     * @type {number}
     * @memberof CompanyModuleAnalytics
     */
    'profitKopecks': number;
}
/**
 * Аналитика по одному ИИ-модулю: тариф клиента, себестоимость, количество и выручка за период. Маржа = (tariffKopecks - costPerUnitKopecks) / tariffKopecks.
 * @export
 * @interface CompanyModuleAnalyticsItem
 */
export interface CompanyModuleAnalyticsItem {
    /**
     * Код модуля
     * @type {string}
     * @memberof CompanyModuleAnalyticsItem
     */
    'module': CompanyModuleAnalyticsItemModule;
    /**
     * Название модуля для отображения
     * @type {string}
     * @memberof CompanyModuleAnalyticsItem
     */
    'moduleName': string;
    /**
     * Тариф клиента за единицу в копейках
     * @type {number}
     * @memberof CompanyModuleAnalyticsItem
     */
    'tariffKopecks': number;
    /**
     * Себестоимость за единицу в копейках
     * @type {number}
     * @memberof CompanyModuleAnalyticsItem
     */
    'costPerUnitKopecks': number;
    /**
     * Количество за период
     * @type {number}
     * @memberof CompanyModuleAnalyticsItem
     */
    'units': number;
    /**
     * Выручка за период (расход клиента) в копейках
     * @type {number}
     * @memberof CompanyModuleAnalyticsItem
     */
    'revenueKopecks': number;
    /**
     * Себестоимость за период в копейках (costPerUnit * units)
     * @type {number}
     * @memberof CompanyModuleAnalyticsItem
     */
    'costKopecks': number;
}

export const CompanyModuleAnalyticsItemModule = {
    SEARCH: 'SEARCH',
    DIALOG: 'DIALOG',
    INTERVIEW: 'INTERVIEW'
} as const;

export type CompanyModuleAnalyticsItemModule = typeof CompanyModuleAnalyticsItemModule[keyof typeof CompanyModuleAnalyticsItemModule];

/**
 * Установка per-company тарифов на ИИ-модули
 * @export
 * @interface CompanyPricingRequest
 */
export interface CompanyPricingRequest {
    /**
     * Цена скоринга за единицу в копейках
     * @type {number}
     * @memberof CompanyPricingRequest
     */
    'searchCreditsPriceKopecks'?: number;
    /**
     * Цена диалога за единицу в копейках
     * @type {number}
     * @memberof CompanyPricingRequest
     */
    'dialogCreditsPriceKopecks'?: number;
    /**
     * Цена скрининга за единицу в копейках
     * @type {number}
     * @memberof CompanyPricingRequest
     */
    'interviewCreditsPriceKopecks'?: number;
}
/**
 * Текущие тарифы компании
 * @export
 * @interface CompanyPricingResponse
 */
export interface CompanyPricingResponse {
    /**
     * 
     * @type {number}
     * @memberof CompanyPricingResponse
     */
    'companyId': number;
    /**
     * Цена скоринга (per-company или глобальная)
     * @type {number}
     * @memberof CompanyPricingResponse
     */
    'searchCreditsPriceKopecks': number;
    /**
     * Цена диалога
     * @type {number}
     * @memberof CompanyPricingResponse
     */
    'dialogCreditsPriceKopecks': number;
    /**
     * Цена скрининга
     * @type {number}
     * @memberof CompanyPricingResponse
     */
    'interviewCreditsPriceKopecks': number;
    /**
     * true если цена скоринга — per-company (не глобальная)
     * @type {boolean}
     * @memberof CompanyPricingResponse
     */
    'isSearchCustom'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyPricingResponse
     */
    'isDialogCustom'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyPricingResponse
     */
    'isInterviewCustom'?: boolean;
}
/**
 * Статистика компании по ИИ-модулям за период
 * @export
 * @interface CompanyStats
 */
export interface CompanyStats {
    /**
     * Текущий баланс в копейках
     * @type {number}
     * @memberof CompanyStats
     */
    'balanceKopecks': number;
    /**
     * Расход на скоринг резюме в копейках
     * @type {number}
     * @memberof CompanyStats
     */
    'searchKopecks': number;
    /**
     * Количество скорингов
     * @type {number}
     * @memberof CompanyStats
     */
    'searchUnits': number;
    /**
     * Изменение расхода на скоринг относительно предыдущего периода в копейках
     * @type {number}
     * @memberof CompanyStats
     */
    'searchDeltaKopecks'?: number;
    /**
     * Расход на диалоги с ИИ в копейках
     * @type {number}
     * @memberof CompanyStats
     */
    'dialogKopecks': number;
    /**
     * Количество диалогов
     * @type {number}
     * @memberof CompanyStats
     */
    'dialogUnits': number;
    /**
     * Изменение расхода на диалоги в копейках
     * @type {number}
     * @memberof CompanyStats
     */
    'dialogDeltaKopecks'?: number;
    /**
     * Расход на ИИ-скрининг в копейках
     * @type {number}
     * @memberof CompanyStats
     */
    'interviewKopecks': number;
    /**
     * Количество скринингов
     * @type {number}
     * @memberof CompanyStats
     */
    'interviewUnits': number;
    /**
     * Изменение расхода на скрининг в копейках
     * @type {number}
     * @memberof CompanyStats
     */
    'interviewDeltaKopecks'?: number;
    /**
     * Общий расход за период в копейках
     * @type {number}
     * @memberof CompanyStats
     */
    'totalSpentKopecks': number;
}
/**
 * Запрос на пополнение баланса компании
 * @export
 * @interface CompanyTopUpRequest
 */
export interface CompanyTopUpRequest {
    /**
     * Сумма пополнения в копейках
     * @type {number}
     * @memberof CompanyTopUpRequest
     */
    'amountKopecks': number;
    /**
     * Комментарий к пополнению
     * @type {string}
     * @memberof CompanyTopUpRequest
     */
    'reason'?: string | null;
}
/**
 * Запрос на обновление компании
 * @export
 * @interface CompanyUpdateRequest
 */
export interface CompanyUpdateRequest {
    /**
     * Название компании
     * @type {string}
     * @memberof CompanyUpdateRequest
     */
    'name': string;
    /**
     * Email владельца (логин)
     * @type {string}
     * @memberof CompanyUpdateRequest
     */
    'ownerEmail'?: string;
    /**
     * Описание деятельности компании
     * @type {string}
     * @memberof CompanyUpdateRequest
     */
    'description'?: string;
    /**
     * Статус компании
     * @type {string}
     * @memberof CompanyUpdateRequest
     */
    'status'?: CompanyUpdateRequestStatus;
    /**
     * Максимальное количество мест
     * @type {number}
     * @memberof CompanyUpdateRequest
     */
    'maxAccounts'?: number;
    /**
     * Дата начала подписки
     * @type {string}
     * @memberof CompanyUpdateRequest
     */
    'subscriptionStartDate'?: string | null;
    /**
     * Дата начала пилота
     * @type {string}
     * @memberof CompanyUpdateRequest
     */
    'pilotStartDate'?: string | null;
    /**
     * Цена скоринга за единицу в копейках
     * @type {number}
     * @memberof CompanyUpdateRequest
     */
    'searchCreditsPriceKopecks'?: number;
    /**
     * Цена диалога за единицу в копейках
     * @type {number}
     * @memberof CompanyUpdateRequest
     */
    'dialogCreditsPriceKopecks'?: number;
    /**
     * Цена скрининга за единицу в копейках
     * @type {number}
     * @memberof CompanyUpdateRequest
     */
    'interviewCreditsPriceKopecks'?: number;
    /**
     * Разрешено ли использование eStaff
     * @type {boolean}
     * @memberof CompanyUpdateRequest
     */
    'estaffEnabled'?: boolean;
}

export const CompanyUpdateRequestStatus = {
    ACTIVE: 'ACTIVE',
    PILOT: 'PILOT',
    SUSPENDED: 'SUSPENDED',
    INACTIVE: 'INACTIVE'
} as const;

export type CompanyUpdateRequestStatus = typeof CompanyUpdateRequestStatus[keyof typeof CompanyUpdateRequestStatus];

/**
 * Стандартный ответ об ошибке
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * Сообщение об ошибке
     * @type {string}
     * @memberof ErrorResponse
     */
    'message': string;
    /**
     * Список ошибок валидации
     * @type {Array<string>}
     * @memberof ErrorResponse
     */
    'errors'?: Array<string>;
}
/**
 * Базовый класс для всех пагинированных ответов
 * @export
 * @interface PaginatedResponse
 */
export interface PaginatedResponse {
    /**
     * Список элементов на текущей странице
     * @type {Array<object>}
     * @memberof PaginatedResponse
     */
    'content': Array<object>;
    /**
     * Общее количество элементов
     * @type {number}
     * @memberof PaginatedResponse
     */
    'totalElements': number;
    /**
     * Общее количество страниц
     * @type {number}
     * @memberof PaginatedResponse
     */
    'totalPages': number;
    /**
     * Номер текущей страницы (начиная с 0)
     * @type {number}
     * @memberof PaginatedResponse
     */
    'number': number;
    /**
     * Размер страницы
     * @type {number}
     * @memberof PaginatedResponse
     */
    'size': number;
}
/**
 * Краткая информация о вакансии
 * @export
 * @interface PositionSummary
 */
export interface PositionSummary {
    /**
     * ID вакансии
     * @type {number}
     * @memberof PositionSummary
     */
    'id': number;
    /**
     * Название вакансии
     * @type {string}
     * @memberof PositionSummary
     */
    'title': string;
    /**
     * Описание вакансии
     * @type {string}
     * @memberof PositionSummary
     */
    'description'?: string | null;
    /**
     * Статус вакансии
     * @type {string}
     * @memberof PositionSummary
     */
    'status': PositionSummaryStatus;
    /**
     * ID команды
     * @type {number}
     * @memberof PositionSummary
     */
    'teamId'?: number | null;
}

export const PositionSummaryStatus = {
    OPEN: 'OPEN',
    CLOSED: 'CLOSED',
    DRAFT: 'DRAFT'
} as const;

export type PositionSummaryStatus = typeof PositionSummaryStatus[keyof typeof PositionSummaryStatus];

/**
 * Краткая информация о команде
 * @export
 * @interface TeamSummary
 */
export interface TeamSummary {
    /**
     * ID команды
     * @type {number}
     * @memberof TeamSummary
     */
    'id': number;
    /**
     * Название команды
     * @type {string}
     * @memberof TeamSummary
     */
    'name': string;
    /**
     * Описание команды
     * @type {string}
     * @memberof TeamSummary
     */
    'description'?: string | null;
    /**
     * ID владельца команды
     * @type {number}
     * @memberof TeamSummary
     */
    'ownerId': number;
}
/**
 * Запрос на обновление статуса компании
 * @export
 * @interface UpdateStatusRequest
 */
export interface UpdateStatusRequest {
    /**
     * Новый статус компании
     * @type {string}
     * @memberof UpdateStatusRequest
     */
    'status': UpdateStatusRequestStatus;
}

export const UpdateStatusRequestStatus = {
    ACTIVE: 'ACTIVE',
    PILOT: 'PILOT',
    SUSPENDED: 'SUSPENDED',
    INACTIVE: 'INACTIVE'
} as const;

export type UpdateStatusRequestStatus = typeof UpdateStatusRequestStatus[keyof typeof UpdateStatusRequestStatus];


/**
 * CompaniesApi - axios parameter creator
 * @export
 */
export const CompaniesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Назначить нового владельца для компании (только SUPER_ADMIN)
         * @summary Назначить владельца компании
         * @param {number} id ID компании
         * @param {AssignOwnerRequest} assignOwnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignCompanyOwner: async (id: number, assignOwnerRequest: AssignOwnerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('assignCompanyOwner', 'id', id)
            // verify required parameter 'assignOwnerRequest' is not null or undefined
            assertParamExists('assignCompanyOwner', 'assignOwnerRequest', assignOwnerRequest)
            const localVarPath = `/companies/{id}/owner`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication SuperAdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignOwnerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Создает новую клиентскую компанию (только SUPER_ADMIN)
         * @summary Создать компанию
         * @param {CompanyCreateRequest} companyCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompany: async (companyCreateRequest: CompanyCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyCreateRequest' is not null or undefined
            assertParamExists('createCompany', 'companyCreateRequest', companyCreateRequest)
            const localVarPath = `/companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication SuperAdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Удаляет компанию по ID. Доступно только для SUPER_ADMIN. **ВНИМАНИЕ**: Удаление компании приведет к удалению всех связанных данных! 
         * @summary Удалить компанию
         * @param {number} id ID компании
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompany: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCompany', 'id', id)
            const localVarPath = `/companies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication SuperAdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Возвращает информацию о компании по её ID. Доступно только для SUPER_ADMIN. 
         * @summary Получить компанию по ID
         * @param {number} id ID компании
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompany: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCompany', 'id', id)
            const localVarPath = `/companies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication SuperAdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Возвращает баланс, прогноз дней, расходы по модулям (только SUPER_ADMIN)
         * @summary Статистика баланса компании с прогнозом
         * @param {number} id 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyBalanceStats: async (id: number, dateFrom?: string, dateTo?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCompanyBalanceStats', 'id', id)
            const localVarPath = `/companies/{id}/balance-stats`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication SuperAdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString().substring(0,10) :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString().substring(0,10) :
                    dateTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Возвращает по каждому ИИ-модулю тариф клиента, себестоимость за единицу, количество и выручку за период, плюс итоговую финансовую эффективность (выручено/себестоимость/прибыль). Маржа и прибыль вычисляются на фронте из копеек. Только SUPER_ADMIN.
         * @summary Аналитика по ИИ-модулям компании (тариф/себестоимость/маржа/прибыль)
         * @param {number} id 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyModuleAnalytics: async (id: number, dateFrom?: string, dateTo?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCompanyModuleAnalytics', 'id', id)
            const localVarPath = `/companies/{id}/module-analytics`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication SuperAdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString().substring(0,10) :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString().substring(0,10) :
                    dateTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получить per-company тарифы
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyPricing: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCompanyPricing', 'id', id)
            const localVarPath = `/companies/{id}/pricing`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication SuperAdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Получить информацию о компании текущего пользователя (ADMIN/RECRUITER)
         * @summary Получить свою компанию
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyCompany: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/companies/my`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Получить список вакансий компании текущего пользователя (ADMIN/RECRUITER)
         * @summary Получить вакансии своей компании
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyCompanyPositions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/companies/my/positions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Получить список команд компании текущего пользователя (ADMIN/RECRUITER)
         * @summary Получить команды своей компании
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyCompanyTeams: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/companies/my/teams`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Получить список всех клиентских компаний с пагинацией, поиском и сортировкой (только SUPER_ADMIN).  **Возможности:** - Пагинация с настраиваемым размером страницы - Поиск по названию и описанию компании - Сортировка по любому полю - Фильтрация по статусу компании 
         * @summary Получить список всех компаний
         * @param {string} [search] Поиск по названию или описанию компании
         * @param {Array<ListCompaniesStatus>} [status] Фильтр по статусу компании. Поддерживает несколько значений, передаваемых одним параметром через запятую (например, ?status&#x3D;ACTIVE,PILOT). Неизвестные значения игнорируются. Пустой/отсутствующий — без фильтра.
         * @param {number} [page] Номер страницы (начиная с 0)
         * @param {number} [size] Размер страницы
         * @param {string} [sort] Поле для сортировки (name, status, createdAt, updatedAt)
         * @param {string} [dateFrom] Начало периода для статистики (включительно)
         * @param {string} [dateTo] Конец периода для статистики (включительно)
         * @param {boolean} [includeStats] Включить статистику по модулям в ответ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanies: async (search?: string, status?: Array<ListCompaniesStatus>, page?: number, size?: number, sort?: string, dateFrom?: string, dateTo?: string, includeStats?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication SuperAdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status) {
                localVarQueryParameter['status'] = status.join(COLLECTION_FORMATS.csv);
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString().substring(0,10) :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString().substring(0,10) :
                    dateTo;
            }

            if (includeStats !== undefined) {
                localVarQueryParameter['includeStats'] = includeStats;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Установить per-company тарифы на ИИ-модули
         * @param {number} id 
         * @param {CompanyPricingRequest} companyPricingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCompanyPricing: async (id: number, companyPricingRequest: CompanyPricingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('setCompanyPricing', 'id', id)
            // verify required parameter 'companyPricingRequest' is not null or undefined
            assertParamExists('setCompanyPricing', 'companyPricingRequest', companyPricingRequest)
            const localVarPath = `/companies/{id}/pricing`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication SuperAdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyPricingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Пополнить рублёвый баланс компании (только SUPER_ADMIN)
         * @summary Пополнить баланс компании
         * @param {number} id ID компании
         * @param {CompanyTopUpRequest} companyTopUpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        topUpCompanyBalance: async (id: number, companyTopUpRequest: CompanyTopUpRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('topUpCompanyBalance', 'id', id)
            // verify required parameter 'companyTopUpRequest' is not null or undefined
            assertParamExists('topUpCompanyBalance', 'companyTopUpRequest', companyTopUpRequest)
            const localVarPath = `/companies/{id}/top-up`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication SuperAdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyTopUpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Обновляет информацию о компании. Доступно только для SUPER_ADMIN. 
         * @summary Обновить компанию
         * @param {number} id ID компании
         * @param {CompanyUpdateRequest} companyUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompany: async (id: number, companyUpdateRequest: CompanyUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCompany', 'id', id)
            // verify required parameter 'companyUpdateRequest' is not null or undefined
            assertParamExists('updateCompany', 'companyUpdateRequest', companyUpdateRequest)
            const localVarPath = `/companies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication SuperAdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Обновить статус компании (только SUPER_ADMIN)
         * @summary Обновить статус компании
         * @param {number} id ID компании
         * @param {UpdateStatusRequest} updateStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyStatus: async (id: number, updateStatusRequest: UpdateStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCompanyStatus', 'id', id)
            // verify required parameter 'updateStatusRequest' is not null or undefined
            assertParamExists('updateCompanyStatus', 'updateStatusRequest', updateStatusRequest)
            const localVarPath = `/companies/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication SuperAdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompaniesApi - functional programming interface
 * @export
 */
export const CompaniesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompaniesApiAxiosParamCreator(configuration)
    return {
        /**
         * Назначить нового владельца для компании (только SUPER_ADMIN)
         * @summary Назначить владельца компании
         * @param {number} id ID компании
         * @param {AssignOwnerRequest} assignOwnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignCompanyOwner(id: number, assignOwnerRequest: AssignOwnerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignCompanyOwner(id, assignOwnerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompaniesApi.assignCompanyOwner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Создает новую клиентскую компанию (только SUPER_ADMIN)
         * @summary Создать компанию
         * @param {CompanyCreateRequest} companyCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCompany(companyCreateRequest: CompanyCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCompany(companyCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompaniesApi.createCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Удаляет компанию по ID. Доступно только для SUPER_ADMIN. **ВНИМАНИЕ**: Удаление компании приведет к удалению всех связанных данных! 
         * @summary Удалить компанию
         * @param {number} id ID компании
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCompany(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCompany(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompaniesApi.deleteCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Возвращает информацию о компании по её ID. Доступно только для SUPER_ADMIN. 
         * @summary Получить компанию по ID
         * @param {number} id ID компании
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompany(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompany(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompaniesApi.getCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Возвращает баланс, прогноз дней, расходы по модулям (только SUPER_ADMIN)
         * @summary Статистика баланса компании с прогнозом
         * @param {number} id 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyBalanceStats(id: number, dateFrom?: string, dateTo?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyBalanceStats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyBalanceStats(id, dateFrom, dateTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompaniesApi.getCompanyBalanceStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Возвращает по каждому ИИ-модулю тариф клиента, себестоимость за единицу, количество и выручку за период, плюс итоговую финансовую эффективность (выручено/себестоимость/прибыль). Маржа и прибыль вычисляются на фронте из копеек. Только SUPER_ADMIN.
         * @summary Аналитика по ИИ-модулям компании (тариф/себестоимость/маржа/прибыль)
         * @param {number} id 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyModuleAnalytics(id: number, dateFrom?: string, dateTo?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyModuleAnalytics>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyModuleAnalytics(id, dateFrom, dateTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompaniesApi.getCompanyModuleAnalytics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получить per-company тарифы
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyPricing(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyPricingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyPricing(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompaniesApi.getCompanyPricing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Получить информацию о компании текущего пользователя (ADMIN/RECRUITER)
         * @summary Получить свою компанию
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyCompany(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyCompany(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompaniesApi.getMyCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Получить список вакансий компании текущего пользователя (ADMIN/RECRUITER)
         * @summary Получить вакансии своей компании
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyCompanyPositions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PositionSummary>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyCompanyPositions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompaniesApi.getMyCompanyPositions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Получить список команд компании текущего пользователя (ADMIN/RECRUITER)
         * @summary Получить команды своей компании
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyCompanyTeams(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TeamSummary>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyCompanyTeams(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompaniesApi.getMyCompanyTeams']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Получить список всех клиентских компаний с пагинацией, поиском и сортировкой (только SUPER_ADMIN).  **Возможности:** - Пагинация с настраиваемым размером страницы - Поиск по названию и описанию компании - Сортировка по любому полю - Фильтрация по статусу компании 
         * @summary Получить список всех компаний
         * @param {string} [search] Поиск по названию или описанию компании
         * @param {Array<ListCompaniesStatus>} [status] Фильтр по статусу компании. Поддерживает несколько значений, передаваемых одним параметром через запятую (например, ?status&#x3D;ACTIVE,PILOT). Неизвестные значения игнорируются. Пустой/отсутствующий — без фильтра.
         * @param {number} [page] Номер страницы (начиная с 0)
         * @param {number} [size] Размер страницы
         * @param {string} [sort] Поле для сортировки (name, status, createdAt, updatedAt)
         * @param {string} [dateFrom] Начало периода для статистики (включительно)
         * @param {string} [dateTo] Конец периода для статистики (включительно)
         * @param {boolean} [includeStats] Включить статистику по модулям в ответ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCompanies(search?: string, status?: Array<ListCompaniesStatus>, page?: number, size?: number, sort?: string, dateFrom?: string, dateTo?: string, includeStats?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompaniesPaginatedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCompanies(search, status, page, size, sort, dateFrom, dateTo, includeStats, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompaniesApi.listCompanies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Установить per-company тарифы на ИИ-модули
         * @param {number} id 
         * @param {CompanyPricingRequest} companyPricingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setCompanyPricing(id: number, companyPricingRequest: CompanyPricingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyPricingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setCompanyPricing(id, companyPricingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompaniesApi.setCompanyPricing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Пополнить рублёвый баланс компании (только SUPER_ADMIN)
         * @summary Пополнить баланс компании
         * @param {number} id ID компании
         * @param {CompanyTopUpRequest} companyTopUpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async topUpCompanyBalance(id: number, companyTopUpRequest: CompanyTopUpRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.topUpCompanyBalance(id, companyTopUpRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompaniesApi.topUpCompanyBalance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Обновляет информацию о компании. Доступно только для SUPER_ADMIN. 
         * @summary Обновить компанию
         * @param {number} id ID компании
         * @param {CompanyUpdateRequest} companyUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCompany(id: number, companyUpdateRequest: CompanyUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCompany(id, companyUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompaniesApi.updateCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Обновить статус компании (только SUPER_ADMIN)
         * @summary Обновить статус компании
         * @param {number} id ID компании
         * @param {UpdateStatusRequest} updateStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCompanyStatus(id: number, updateStatusRequest: UpdateStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Company>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCompanyStatus(id, updateStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompaniesApi.updateCompanyStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CompaniesApi - factory interface
 * @export
 */
export const CompaniesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompaniesApiFp(configuration)
    return {
        /**
         * Назначить нового владельца для компании (только SUPER_ADMIN)
         * @summary Назначить владельца компании
         * @param {number} id ID компании
         * @param {AssignOwnerRequest} assignOwnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignCompanyOwner(id: number, assignOwnerRequest: AssignOwnerRequest, options?: RawAxiosRequestConfig): AxiosPromise<Company> {
            return localVarFp.assignCompanyOwner(id, assignOwnerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Создает новую клиентскую компанию (только SUPER_ADMIN)
         * @summary Создать компанию
         * @param {CompanyCreateRequest} companyCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCompany(companyCreateRequest: CompanyCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Company> {
            return localVarFp.createCompany(companyCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Удаляет компанию по ID. Доступно только для SUPER_ADMIN. **ВНИМАНИЕ**: Удаление компании приведет к удалению всех связанных данных! 
         * @summary Удалить компанию
         * @param {number} id ID компании
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCompany(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteCompany(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Возвращает информацию о компании по её ID. Доступно только для SUPER_ADMIN. 
         * @summary Получить компанию по ID
         * @param {number} id ID компании
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompany(id: number, options?: RawAxiosRequestConfig): AxiosPromise<Company> {
            return localVarFp.getCompany(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Возвращает баланс, прогноз дней, расходы по модулям (только SUPER_ADMIN)
         * @summary Статистика баланса компании с прогнозом
         * @param {number} id 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyBalanceStats(id: number, dateFrom?: string, dateTo?: string, options?: RawAxiosRequestConfig): AxiosPromise<CompanyBalanceStats> {
            return localVarFp.getCompanyBalanceStats(id, dateFrom, dateTo, options).then((request) => request(axios, basePath));
        },
        /**
         * Возвращает по каждому ИИ-модулю тариф клиента, себестоимость за единицу, количество и выручку за период, плюс итоговую финансовую эффективность (выручено/себестоимость/прибыль). Маржа и прибыль вычисляются на фронте из копеек. Только SUPER_ADMIN.
         * @summary Аналитика по ИИ-модулям компании (тариф/себестоимость/маржа/прибыль)
         * @param {number} id 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyModuleAnalytics(id: number, dateFrom?: string, dateTo?: string, options?: RawAxiosRequestConfig): AxiosPromise<CompanyModuleAnalytics> {
            return localVarFp.getCompanyModuleAnalytics(id, dateFrom, dateTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получить per-company тарифы
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyPricing(id: number, options?: RawAxiosRequestConfig): AxiosPromise<CompanyPricingResponse> {
            return localVarFp.getCompanyPricing(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Получить информацию о компании текущего пользователя (ADMIN/RECRUITER)
         * @summary Получить свою компанию
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyCompany(options?: RawAxiosRequestConfig): AxiosPromise<Company> {
            return localVarFp.getMyCompany(options).then((request) => request(axios, basePath));
        },
        /**
         * Получить список вакансий компании текущего пользователя (ADMIN/RECRUITER)
         * @summary Получить вакансии своей компании
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyCompanyPositions(options?: RawAxiosRequestConfig): AxiosPromise<Array<PositionSummary>> {
            return localVarFp.getMyCompanyPositions(options).then((request) => request(axios, basePath));
        },
        /**
         * Получить список команд компании текущего пользователя (ADMIN/RECRUITER)
         * @summary Получить команды своей компании
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyCompanyTeams(options?: RawAxiosRequestConfig): AxiosPromise<Array<TeamSummary>> {
            return localVarFp.getMyCompanyTeams(options).then((request) => request(axios, basePath));
        },
        /**
         * Получить список всех клиентских компаний с пагинацией, поиском и сортировкой (только SUPER_ADMIN).  **Возможности:** - Пагинация с настраиваемым размером страницы - Поиск по названию и описанию компании - Сортировка по любому полю - Фильтрация по статусу компании 
         * @summary Получить список всех компаний
         * @param {string} [search] Поиск по названию или описанию компании
         * @param {Array<ListCompaniesStatus>} [status] Фильтр по статусу компании. Поддерживает несколько значений, передаваемых одним параметром через запятую (например, ?status&#x3D;ACTIVE,PILOT). Неизвестные значения игнорируются. Пустой/отсутствующий — без фильтра.
         * @param {number} [page] Номер страницы (начиная с 0)
         * @param {number} [size] Размер страницы
         * @param {string} [sort] Поле для сортировки (name, status, createdAt, updatedAt)
         * @param {string} [dateFrom] Начало периода для статистики (включительно)
         * @param {string} [dateTo] Конец периода для статистики (включительно)
         * @param {boolean} [includeStats] Включить статистику по модулям в ответ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCompanies(search?: string, status?: Array<ListCompaniesStatus>, page?: number, size?: number, sort?: string, dateFrom?: string, dateTo?: string, includeStats?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<CompaniesPaginatedResponse> {
            return localVarFp.listCompanies(search, status, page, size, sort, dateFrom, dateTo, includeStats, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Установить per-company тарифы на ИИ-модули
         * @param {number} id 
         * @param {CompanyPricingRequest} companyPricingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setCompanyPricing(id: number, companyPricingRequest: CompanyPricingRequest, options?: RawAxiosRequestConfig): AxiosPromise<CompanyPricingResponse> {
            return localVarFp.setCompanyPricing(id, companyPricingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Пополнить рублёвый баланс компании (только SUPER_ADMIN)
         * @summary Пополнить баланс компании
         * @param {number} id ID компании
         * @param {CompanyTopUpRequest} companyTopUpRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        topUpCompanyBalance(id: number, companyTopUpRequest: CompanyTopUpRequest, options?: RawAxiosRequestConfig): AxiosPromise<Company> {
            return localVarFp.topUpCompanyBalance(id, companyTopUpRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Обновляет информацию о компании. Доступно только для SUPER_ADMIN. 
         * @summary Обновить компанию
         * @param {number} id ID компании
         * @param {CompanyUpdateRequest} companyUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompany(id: number, companyUpdateRequest: CompanyUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Company> {
            return localVarFp.updateCompany(id, companyUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Обновить статус компании (только SUPER_ADMIN)
         * @summary Обновить статус компании
         * @param {number} id ID компании
         * @param {UpdateStatusRequest} updateStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyStatus(id: number, updateStatusRequest: UpdateStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<Company> {
            return localVarFp.updateCompanyStatus(id, updateStatusRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompaniesApi - object-oriented interface
 * @export
 * @class CompaniesApi
 * @extends {BaseAPI}
 */
export class CompaniesApi extends BaseAPI {
    /**
     * Назначить нового владельца для компании (только SUPER_ADMIN)
     * @summary Назначить владельца компании
     * @param {number} id ID компании
     * @param {AssignOwnerRequest} assignOwnerRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    public assignCompanyOwner(id: number, assignOwnerRequest: AssignOwnerRequest, options?: RawAxiosRequestConfig) {
        return CompaniesApiFp(this.configuration).assignCompanyOwner(id, assignOwnerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Создает новую клиентскую компанию (только SUPER_ADMIN)
     * @summary Создать компанию
     * @param {CompanyCreateRequest} companyCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    public createCompany(companyCreateRequest: CompanyCreateRequest, options?: RawAxiosRequestConfig) {
        return CompaniesApiFp(this.configuration).createCompany(companyCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Удаляет компанию по ID. Доступно только для SUPER_ADMIN. **ВНИМАНИЕ**: Удаление компании приведет к удалению всех связанных данных! 
     * @summary Удалить компанию
     * @param {number} id ID компании
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    public deleteCompany(id: number, options?: RawAxiosRequestConfig) {
        return CompaniesApiFp(this.configuration).deleteCompany(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Возвращает информацию о компании по её ID. Доступно только для SUPER_ADMIN. 
     * @summary Получить компанию по ID
     * @param {number} id ID компании
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    public getCompany(id: number, options?: RawAxiosRequestConfig) {
        return CompaniesApiFp(this.configuration).getCompany(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Возвращает баланс, прогноз дней, расходы по модулям (только SUPER_ADMIN)
     * @summary Статистика баланса компании с прогнозом
     * @param {number} id 
     * @param {string} [dateFrom] 
     * @param {string} [dateTo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    public getCompanyBalanceStats(id: number, dateFrom?: string, dateTo?: string, options?: RawAxiosRequestConfig) {
        return CompaniesApiFp(this.configuration).getCompanyBalanceStats(id, dateFrom, dateTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Возвращает по каждому ИИ-модулю тариф клиента, себестоимость за единицу, количество и выручку за период, плюс итоговую финансовую эффективность (выручено/себестоимость/прибыль). Маржа и прибыль вычисляются на фронте из копеек. Только SUPER_ADMIN.
     * @summary Аналитика по ИИ-модулям компании (тариф/себестоимость/маржа/прибыль)
     * @param {number} id 
     * @param {string} [dateFrom] 
     * @param {string} [dateTo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    public getCompanyModuleAnalytics(id: number, dateFrom?: string, dateTo?: string, options?: RawAxiosRequestConfig) {
        return CompaniesApiFp(this.configuration).getCompanyModuleAnalytics(id, dateFrom, dateTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получить per-company тарифы
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    public getCompanyPricing(id: number, options?: RawAxiosRequestConfig) {
        return CompaniesApiFp(this.configuration).getCompanyPricing(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Получить информацию о компании текущего пользователя (ADMIN/RECRUITER)
     * @summary Получить свою компанию
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    public getMyCompany(options?: RawAxiosRequestConfig) {
        return CompaniesApiFp(this.configuration).getMyCompany(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Получить список вакансий компании текущего пользователя (ADMIN/RECRUITER)
     * @summary Получить вакансии своей компании
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    public getMyCompanyPositions(options?: RawAxiosRequestConfig) {
        return CompaniesApiFp(this.configuration).getMyCompanyPositions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Получить список команд компании текущего пользователя (ADMIN/RECRUITER)
     * @summary Получить команды своей компании
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    public getMyCompanyTeams(options?: RawAxiosRequestConfig) {
        return CompaniesApiFp(this.configuration).getMyCompanyTeams(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Получить список всех клиентских компаний с пагинацией, поиском и сортировкой (только SUPER_ADMIN).  **Возможности:** - Пагинация с настраиваемым размером страницы - Поиск по названию и описанию компании - Сортировка по любому полю - Фильтрация по статусу компании 
     * @summary Получить список всех компаний
     * @param {string} [search] Поиск по названию или описанию компании
     * @param {Array<ListCompaniesStatus>} [status] Фильтр по статусу компании. Поддерживает несколько значений, передаваемых одним параметром через запятую (например, ?status&#x3D;ACTIVE,PILOT). Неизвестные значения игнорируются. Пустой/отсутствующий — без фильтра.
     * @param {number} [page] Номер страницы (начиная с 0)
     * @param {number} [size] Размер страницы
     * @param {string} [sort] Поле для сортировки (name, status, createdAt, updatedAt)
     * @param {string} [dateFrom] Начало периода для статистики (включительно)
     * @param {string} [dateTo] Конец периода для статистики (включительно)
     * @param {boolean} [includeStats] Включить статистику по модулям в ответ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    public listCompanies(search?: string, status?: Array<ListCompaniesStatus>, page?: number, size?: number, sort?: string, dateFrom?: string, dateTo?: string, includeStats?: boolean, options?: RawAxiosRequestConfig) {
        return CompaniesApiFp(this.configuration).listCompanies(search, status, page, size, sort, dateFrom, dateTo, includeStats, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Установить per-company тарифы на ИИ-модули
     * @param {number} id 
     * @param {CompanyPricingRequest} companyPricingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    public setCompanyPricing(id: number, companyPricingRequest: CompanyPricingRequest, options?: RawAxiosRequestConfig) {
        return CompaniesApiFp(this.configuration).setCompanyPricing(id, companyPricingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Пополнить рублёвый баланс компании (только SUPER_ADMIN)
     * @summary Пополнить баланс компании
     * @param {number} id ID компании
     * @param {CompanyTopUpRequest} companyTopUpRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    public topUpCompanyBalance(id: number, companyTopUpRequest: CompanyTopUpRequest, options?: RawAxiosRequestConfig) {
        return CompaniesApiFp(this.configuration).topUpCompanyBalance(id, companyTopUpRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Обновляет информацию о компании. Доступно только для SUPER_ADMIN. 
     * @summary Обновить компанию
     * @param {number} id ID компании
     * @param {CompanyUpdateRequest} companyUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    public updateCompany(id: number, companyUpdateRequest: CompanyUpdateRequest, options?: RawAxiosRequestConfig) {
        return CompaniesApiFp(this.configuration).updateCompany(id, companyUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Обновить статус компании (только SUPER_ADMIN)
     * @summary Обновить статус компании
     * @param {number} id ID компании
     * @param {UpdateStatusRequest} updateStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    public updateCompanyStatus(id: number, updateStatusRequest: UpdateStatusRequest, options?: RawAxiosRequestConfig) {
        return CompaniesApiFp(this.configuration).updateCompanyStatus(id, updateStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListCompaniesStatus = {
    ACTIVE: 'ACTIVE',
    PILOT: 'PILOT',
    SUSPENDED: 'SUSPENDED',
    INACTIVE: 'INACTIVE'
} as const;
export type ListCompaniesStatus = typeof ListCompaniesStatus[keyof typeof ListCompaniesStatus];


